import React, { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../store';
import { IEventRound } from '../../../../store/admin/eventRounds/store';
import { IAdminEvent } from '../../../../store/admin/events/store';

import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import { useBoolean } from '../../../common/Hooks/useBoolean.hook';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';

interface ICompleteRound {
  clubId: string;
  eventId: string;
  roundId: string;
  navigate: any;
}

export const CompleteRound = (props: ICompleteRound) => {
  const { clubId, eventId, navigate, roundId } = props;
  const {
    actions: {
      adminEvents: { editRound }
    },
    adminEvents
  } = useContext(GlobalContext);

  const [event, setEvent] = useState<IAdminEvent | undefined>();
  const [round, setRound] = useState<IEventRound | undefined>();
  const [roundIds, setRoundIds] = useState<number[]>([]);
  const [roundIdIndex, setRoundIdIndex] = useState<number>(-1);

  const [open, , toggleOpenDialog] = useBoolean(false);

  useEffect(() => {
    setEvent(adminEvents[Number(eventId)]);
  }, [adminEvents]);

  useEffect(() => {
    if (event) {
      setRound(event.rounds.find(eventRound => eventRound.id === Number(roundId)));
    }
  }, [event]);

  useEffect(() => {
    if (event) {
      setRoundIds(event.rounds.map(eventRound => eventRound.id));
    }
  }, [event]);

  useEffect(() => {
    setRoundIdIndex(roundIds.findIndex(rid => rid === Number(roundId)));
  }, [roundIds, roundId]);

  const goToEvents = () => navigate(`/staff/club/${clubId}/events`);

  const onCompleteRound = async () => {
    if (event && round) {
      const completedRound: IEventRound = { ...round, status: 'completed' };

      await editRound(Number(clubId), event, completedRound);

      if (roundIdIndex === roundIds.length - 1) {
        navigate(`/staff/club/${clubId}/event/${eventId}/complete`);
      } else {
        toggleOpenDialog();
      }
    }
  };

  const goToNextRound = () =>
    navigate(`/staff/club/${clubId}/event/${eventId}/round/${roundIds[roundIdIndex + 1]}`);

  return (
    <>
      <div className="admin-wrapper">
        <div className="event-wizard-page round-setup complete-event">
          <EventWizardStepTitle
            buttonText="COMPLETE ROUND"
            buttonOnClick={onCompleteRound}
            title="COMPLETE ROUND"
          />

          <div className="assign-awards">
            <div className="complete-event">
              <p>
                After the golf is done and scores and awards are entered, click the button below to
                complete the round and post the results. If there is more than one round in this
                event the next round’s setup and tee sheet will become available.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        onClose={toggleOpenDialog}
        open={open}
        className="select-dialog"
        title="ROUND COMPLETE"
        actions={[
          <Button
            key="button-remove-cancel"
            fullWidth={true}
            onClick={goToEvents}
            className="confirm-removal-button"
            color="primary"
          >
            EXIT EVENT
          </Button>,
          <Button
            key="button-remove-ok"
            fullWidth={true}
            onClick={goToNextRound}
            variant="contained"
            className="confirm-removal-button"
            color="primary"
          >
            CONTINUE
          </Button>
        ]}
      />
    </>
  );
};
